{
  "labels": {
    "paste": "Einfügen",
    "pasteAsPlaintext": "Als unformatierten Text einfügen",
    "pasteCharts": "Diagramme einfügen",
    "selectAll": "Alle auswählen",
    "multiSelect": "Element zur Auswahl hinzufügen",
    "moveCanvas": "Leinwand verschieben",
    "cut": "Ausschneiden",
    "copy": "Kopieren",
    "copyAsPng": "In Zwischenablage kopieren (PNG)",
    "copyAsSvg": "In Zwischenablage kopieren (SVG)",
    "copyText": "In die Zwischenablage als Text kopieren",
    "copySource": "Quelle in Zwischenablage kopieren",
    "convertToCode": "In Code konvertieren",
    "bringForward": "Nach vorne",
    "sendToBack": "In den Hintergrund",
    "bringToFront": "In den Vordergrund",
    "sendBackward": "Nach hinten",
    "delete": "Löschen",
    "copyStyles": "Formatierung kopieren",
    "pasteStyles": "Formatierung übernehmen",
    "stroke": "Strich",
    "changeStroke": "Strichfarbe ändern",
    "background": "Hintergrund",
    "changeBackground": "Hintergrundfarbe ändern",
    "fill": "Füllung",
    "strokeWidth": "Strichstärke",
    "strokeStyle": "Konturstil",
    "strokeStyle_solid": "Durchgezogen",
    "strokeStyle_dashed": "Gestrichelt",
    "strokeStyle_dotted": "Gepunktet",
    "sloppiness": "Sauberkeit",
    "opacity": "Deckkraft",
    "textAlign": "Textausrichtung",
    "edges": "Kanten",
    "sharp": "Scharf",
    "round": "Rund",
    "arrowheads": "Pfeilspitzen",
    "arrowhead_none": "Keine",
    "arrowhead_arrow": "Pfeil",
    "arrowhead_bar": "Balken",
    "arrowhead_circle": "Kreis",
    "arrowhead_circle_outline": "Kreis (Umrandung)",
    "arrowhead_triangle": "Dreieck",
    "arrowhead_triangle_outline": "Dreieck (Umrandung)",
    "arrowhead_diamond": "Raute",
    "arrowhead_diamond_outline": "Raute (Umrandung)",
    "arrowhead_crowfoot_many": "Krähenfuß (viele)",
    "arrowhead_crowfoot_one": "Krähenfuß (einer)",
    "arrowhead_crowfoot_one_or_many": "Krähenfuß (einer oder viele)",
    "more_options": "Weitere Optionen",
    "arrowtypes": "Pfeiltyp",
    "arrowtype_sharp": "Scharfer Pfeil",
    "arrowtype_round": "Gebogener Pfeil",
    "arrowtype_elbowed": "Ellenbogen-Pfeil",
    "fontSize": "Schriftgröße",
    "fontFamily": "Schriftfamilie",
    "addWatermark": "\"Made with Excalidraw\" hinzufügen",
    "handDrawn": "Handgezeichnet",
    "normal": "Normal",
    "code": "Code",
    "small": "Klein",
    "medium": "Mittel",
    "large": "Groß",
    "veryLarge": "Sehr groß",
    "solid": "Deckend",
    "hachure": "Schraffiert",
    "zigzag": "Zickzack",
    "crossHatch": "Kreuzschraffiert",
    "thin": "Dünn",
    "bold": "Fett",
    "left": "Links",
    "center": "Zentriert",
    "right": "Rechts",
    "extraBold": "Extra Fett",
    "architect": "Architekt",
    "artist": "Künstler",
    "cartoonist": "Karikaturist",
    "fileTitle": "Dateiname",
    "colorPicker": "Farbauswähler",
    "canvasColors": "Auf Leinwand verwendet",
    "canvasBackground": "Zeichenflächenhintergrund",
    "drawingCanvas": "Leinwand",
    "clearCanvas": "Zeichenfläche löschen",
    "layers": "Ebenen",
    "actions": "Aktionen",
    "language": "Sprache",
    "liveCollaboration": "Live-Zusammenarbeit...",
    "duplicateSelection": "Duplizieren",
    "untitled": "Unbenannt",
    "name": "Name",
    "yourName": "Dein Name",
    "madeWithExcalidraw": "Made with Excalidraw",
    "group": "Auswahl gruppieren",
    "ungroup": "Gruppierung aufheben",
    "collaborators": "Mitarbeitende",
    "toggleGrid": "Raster umschalten",
    "addToLibrary": "Zur Bibliothek hinzufügen",
    "removeFromLibrary": "Aus Bibliothek entfernen",
    "libraryLoadingMessage": "Lade Bibliothek…",
    "libraries": "Bibliotheken durchsuchen",
    "loadingScene": "Lade Zeichnung…",
    "loadScene": "Szene aus Datei laden",
    "align": "Ausrichten",
    "alignTop": "Obere Kanten",
    "alignBottom": "Untere Kanten",
    "alignLeft": "Linke Kanten",
    "alignRight": "Rechte Kanten",
    "centerVertically": "Vertikal zentrieren",
    "centerHorizontally": "Horizontal zentrieren",
    "distributeHorizontally": "Horizontal verteilen",
    "distributeVertically": "Vertikal verteilen",
    "flipHorizontal": "Horizontal spiegeln",
    "flipVertical": "Vertikal spiegeln",
    "viewMode": "Ansichtsmodus",
    "share": "Teilen",
    "showStroke": "Auswahl für Strichfarbe anzeigen",
    "showBackground": "Hintergrundfarbe auswählen",
    "showFonts": "Schriftauswahl anzeigen",
    "toggleTheme": "Helles/dunkles Design umschalten",
    "theme": "Design",
    "personalLib": "Persönliche Bibliothek",
    "excalidrawLib": "Excalidraw Bibliothek",
    "decreaseFontSize": "Schriftgröße verringern",
    "increaseFontSize": "Schriftgröße erhöhen",
    "unbindText": "Text lösen",
    "bindText": "Text an Container binden",
    "createContainerFromText": "Text in Container einbetten",
    "link": {
      "edit": "Link bearbeiten",
      "editEmbed": "Einbettbaren Link bearbeiten",
      "create": "Link hinzufügen",
      "label": "Link",
      "labelEmbed": "Verlinken & einbetten",
      "empty": "Kein Link festgelegt",
      "hint": "Link hier eingeben oder einfügen",
      "goToElement": "Gehe zu Zielelement"
    },
    "lineEditor": {
      "edit": "Linie bearbeiten",
      "editArrow": "Pfeil bearbeiten"
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "Sperren",
      "unlock": "Entsperren",
      "lockAll": "Alle sperren",
      "unlockAll": "Alle entsperren"
    },
    "statusPublished": "Veröffentlicht",
    "sidebarLock": "Seitenleiste offen lassen",
    "selectAllElementsInFrame": "Alle Elemente im Rahmen auswählen",
    "removeAllElementsFromFrame": "Alle Elemente aus dem Rahmen entfernen",
    "eyeDropper": "Farbe von der Zeichenfläche auswählen",
    "textToDiagram": "Text zu Diagramm",
    "prompt": "Eingabe",
    "followUs": "Folge uns",
    "discordChat": "Discord-Chat",
    "zoomToFitViewport": "Zoom auf Ansicht anpassen",
    "zoomToFitSelection": "Zoom auf Auswahl anpassen",
    "zoomToFit": "Zoom auf alle Elemente anpassen",
    "installPWA": "Excalidraw lokal installieren (PWA)",
    "autoResize": "Aktiviere automatische Textgrößenanpassung",
    "imageCropping": "Bild zuschneiden",
    "unCroppedDimension": "Nicht zugeschnittene Dimension",
    "copyElementLink": "Link zum Objekt kopieren",
    "linkToElement": "Link zum Objekt",
    "wrapSelectionInFrame": "Auswahl in Rahmen einbetten",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "Link zum Objekt",
    "desc": "Klicke auf eine Form auf der Zeichenfläche oder füge einen Link ein.",
    "notFound": "Verknüpftes Objekt wurde nicht auf der Zeichenfläche gefunden."
  },
  "library": {
    "noItems": "Noch keine Elemente hinzugefügt...",
    "hint_emptyLibrary": "Wähle ein Element auf der Zeichenfläche, um es hier hinzuzufügen. Oder installiere eine Bibliothek aus dem öffentlichen Verzeichnis.",
    "hint_emptyPrivateLibrary": "Wähle ein Element von der Zeichenfläche, um es hier hinzuzufügen.",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "Auf Zeichenfläche suchen",
    "noMatch": "Keine Treffer gefunden...",
    "singleResult": "Ergebnis",
    "multipleResults": "Ergebnisse",
    "placeholder": "Text auf Zeichenfläche suchen...",
    "frames": "",
    "texts": "Texte"
  },
  "buttons": {
    "clearReset": "Zeichenfläche löschen & Hintergrundfarbe zurücksetzen",
    "exportJSON": "In Datei exportieren",
    "exportImage": "Exportiere Bild...",
    "export": "Speichern als...",
    "copyToClipboard": "In Zwischenablage kopieren",
    "copyLink": "Link kopieren",
    "save": "In aktueller Datei speichern",
    "saveAs": "Speichern unter",
    "load": "Öffnen",
    "getShareableLink": "Teilbaren Link erhalten",
    "close": "Schließen",
    "selectLanguage": "Sprache auswählen",
    "scrollBackToContent": "Zurück zum Inhalt",
    "zoomIn": "Vergrößern",
    "zoomOut": "Verkleinern",
    "resetZoom": "Zoom zurücksetzen",
    "menu": "Menü",
    "done": "Fertig",
    "edit": "Bearbeiten",
    "undo": "Rückgängig machen",
    "redo": "Wiederholen",
    "resetLibrary": "Bibliothek zurücksetzen",
    "createNewRoom": "Neuen Raum erstellen",
    "fullScreen": "Vollbildanzeige",
    "darkMode": "Dunkles Design",
    "lightMode": "Helles Design",
    "systemMode": "System-Modus",
    "zenMode": "Zen-Modus",
    "objectsSnapMode": "Einrasten an Objekten",
    "exitZenMode": "Zen-Modus verlassen",
    "cancel": "Abbrechen",
    "saveLibNames": "",
    "clear": "Löschen",
    "remove": "Entfernen",
    "embed": "Einbettung umschalten",
    "publishLibrary": "",
    "submit": "Absenden",
    "confirm": "Bestätigen",
    "embeddableInteractionButton": "Klicken, um zu interagieren"
  },
  "alerts": {
    "clearReset": "Dies wird die ganze Zeichenfläche löschen. Bist du dir sicher?",
    "couldNotCreateShareableLink": "Konnte keinen teilbaren Link erstellen.",
    "couldNotCreateShareableLinkTooBig": "Konnte keinen teilbaren Link erstellen: Die Zeichnung ist zu groß",
    "couldNotLoadInvalidFile": "Ungültige Datei konnte nicht geladen werden",
    "importBackendFailed": "Import vom Server ist fehlgeschlagen.",
    "cannotExportEmptyCanvas": "Leere Zeichenfläche kann nicht exportiert werden.",
    "couldNotCopyToClipboard": "Kopieren in die Zwischenablage fehlgeschlagen.",
    "decryptFailed": "Daten konnten nicht entschlüsselt werden.",
    "uploadedSecurly": "Der Upload wurde mit Ende-zu-Ende-Verschlüsselung gespeichert. Weder Excalidraw noch Dritte können den Inhalt einsehen.",
    "loadSceneOverridePrompt": "Das Laden einer externen Zeichnung ersetzt den vorhandenen Inhalt. Möchtest du fortfahren?",
    "collabStopOverridePrompt": "Das Stoppen der Sitzung wird deine vorherige, lokal gespeicherte Zeichnung überschreiben. Bist du dir sicher?\n\n(Wenn du deine lokale Zeichnung behalten möchtest, schließe stattdessen den Browser-Tab.)",
    "errorAddingToLibrary": "Das Element konnte nicht zur Bibliothek hinzugefügt werden",
    "errorRemovingFromLibrary": "Das Element konnte nicht aus der Bibliothek entfernt werden",
    "confirmAddLibrary": "Dies fügt {{numShapes}} Form(en) zu deiner Bibliothek hinzu. Bist du dir sicher?",
    "imageDoesNotContainScene": "Dieses Bild scheint keine Szenendaten zu enthalten. Hast Du das Einbetten der Szene während des Exports aktiviert?",
    "cannotRestoreFromImage": "Die Zeichnung konnte aus dieser Bilddatei nicht wiederhergestellt werden",
    "invalidSceneUrl": "Die Szene konnte nicht von der angegebenen URL importiert werden. Sie ist entweder fehlerhaft oder enthält keine gültigen Excalidraw JSON-Daten.",
    "resetLibrary": "Dieses löscht deine Bibliothek. Bist du sicher?",
    "removeItemsFromsLibrary": "{{count}} Element(e) aus der Bibliothek löschen?",
    "invalidEncryptionKey": "Verschlüsselungsschlüssel muss 22 Zeichen lang sein. Die Live-Zusammenarbeit ist deaktiviert.",
    "collabOfflineWarning": "Keine Internetverbindung verfügbar.\nDeine Änderungen werden nicht gespeichert!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "Nicht unterstützter Dateityp.",
    "imageInsertError": "Das Bild konnte nicht eingefügt werden. Versuche es später erneut...",
    "fileTooBig": "Die Datei ist zu groß. Die maximal zulässige Größe ist {{maxSize}}.",
    "svgImageInsertError": "SVG-Bild konnte nicht eingefügt werden. Das SVG-Markup sieht ungültig aus.",
    "failedToFetchImage": "Bild konnte nicht abgerufen werden.",
    "cannotResolveCollabServer": "Konnte keine Verbindung zum Collab-Server herstellen. Bitte lade die Seite neu und versuche es erneut.",
    "importLibraryError": "Bibliothek konnte nicht geladen werden",
    "saveLibraryError": "Bibliothek konnte nicht gespeichert werden. Bitte speichere deine Bibliothek lokal in einer Datei, um sicherzustellen, dass keine Änderungen verloren gehen.",
    "collabSaveFailed": "Keine Speicherung in der Backend-Datenbank möglich. Wenn die Probleme weiterhin bestehen, solltest Du Deine Datei lokal speichern, um sicherzustellen, dass Du Deine Arbeit nicht verlierst.",
    "collabSaveFailed_sizeExceeded": "Keine Speicherung in der Backend-Datenbank möglich, die Zeichenfläche scheint zu groß zu sein. Du solltest Deine Datei lokal speichern, um sicherzustellen, dass Du Deine Arbeit nicht verlierst.",
    "imageToolNotSupported": "Bilder sind deaktiviert.",
    "brave_measure_text_error": {
      "line1": "Sieht so aus, als ob Du den Brave-Browser verwendest und die <bold>aggressive Blockierung von Fingerabdrücken</bold> aktiviert hast.",
      "line2": "Dies könnte dazu führen, dass die <bold>Textelemente</bold> in Ihren Zeichnungen zerstört werden.",
      "line3": "Wir empfehlen dringend, diese Einstellung zu deaktivieren. Dazu kannst Du <link>diesen Schritten</link> folgen.",
      "line4": "Wenn die Deaktivierung dieser Einstellung die fehlerhafte Anzeige von Textelementen nicht behebt, öffne bitte ein <issueLink>Ticket</issueLink> auf unserem GitHub oder schreibe uns auf <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "Einbettbare Elemente können der Bibliothek nicht hinzugefügt werden.",
      "iframe": "IFrame-Elemente können nicht zur Bibliothek hinzugefügt werden.",
      "image": "Unterstützung für das Hinzufügen von Bildern in die Bibliothek kommt bald!"
    },
    "asyncPasteFailedOnRead": "Einfügen fehlgeschlagen (konnte aus der Zwischenablage des Systems nicht gelesen werden).",
    "asyncPasteFailedOnParse": "Einfügen fehlgeschlagen.",
    "copyToSystemClipboardFailed": "Kopieren in die Zwischenablage fehlgeschlagen."
  },
  "toolBar": {
    "selection": "Auswahl",
    "lasso": "",
    "image": "Bild einfügen",
    "rectangle": "Rechteck",
    "diamond": "Raute",
    "ellipse": "Ellipse",
    "arrow": "Pfeil",
    "line": "Linie",
    "freedraw": "Zeichnen",
    "text": "Text",
    "library": "Bibliothek",
    "lock": "Ausgewähltes Werkzeug nach Zeichnen aktiv lassen",
    "penMode": "Stift-Modus - Berührung verhindern",
    "link": "Link für ausgewählte Form hinzufügen / aktualisieren",
    "eraser": "Radierer",
    "frame": "Rahmenwerkzeug",
    "magicframe": "Wireframe zu Code",
    "embeddable": "Web-Einbettung",
    "laser": "Laserpointer",
    "hand": "Hand (Schwenkwerkzeug)",
    "extraTools": "Weitere Werkzeuge",
    "mermaidToExcalidraw": "Mermaid zu Excalidraw",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "Rechteck",
    "diamond": "Raute",
    "ellipse": "Ellipse",
    "arrow": "Pfeil",
    "line": "Linie",
    "freedraw": "Frei zeichnen",
    "text": "Text",
    "image": "Bild",
    "group": "Gruppe",
    "frame": "Rahmen",
    "magicframe": "Wireframe zu Code",
    "embeddable": "Web-Einbettung",
    "selection": "Auswahl",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "Aktionen für Zeichenfläche",
    "selectedShapeActions": "Aktionen für Auswahl",
    "shapes": "Formen"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "Klicken für Linie mit mehreren Punkten, Ziehen für einzelne Linie",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Klicke und ziehe. Lass los, wenn du fertig bist",
    "text": "Tipp: Du kannst auch Text hinzufügen, indem du mit dem Auswahlwerkzeug auf eine beliebige Stelle doppelklickst",
    "embeddable": "Klicken und ziehen, um eine Webseiten-Einbettung zu erstellen",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "Veröffentliche deine eigene Bibliothek",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "Diese Funktion kann wahrscheinlich aktiviert werden, indem die Einstellung \"dom.events.asyncClipboard.clipboardItem\" auf \"true\" gesetzt wird. Um die Browsereinstellungen in Firefox zu ändern, besuche die Seite \"about:config\".",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "Vorschau kann nicht angezeigt werden",
    "canvasTooBig": "Die Leinwand ist möglicherweise zu groß.",
    "canvasTooBigTip": "Tipp: Schiebe die am weitesten entfernten Elemente ein wenig näher zusammen."
  },
  "errorSplash": {
    "headingMain": "Es ist ein Fehler aufgetreten. Versuche <button>die Seite neu zu laden.</button>",
    "clearCanvasMessage": "Wenn das Neuladen nicht funktioniert, versuche <button>die Zeichenfläche zu löschen.</button>",
    "clearCanvasCaveat": " Dies wird zum Verlust von Daten führen ",
    "trackedToSentry": "Der Fehler mit der Kennung {{eventId}} wurde in unserem System registriert.",
    "openIssueMessage": "Wir waren sehr vorsichtig und haben deine Zeichnungsinformationen nicht in die Fehlerinformationen aufgenommen. Wenn deine Zeichnung nicht privat ist, unterstütze uns bitte über unseren <button>Bug-Tracker</button>. Bitte teile die unten stehenden Informationen mit uns im GitHub Issue (Kopieren und Einfügen).",
    "sceneContent": "Zeichnungsinhalt:"
  },
  "shareDialog": {
    "or": "Oder"
  },
  "roomDialog": {
    "desc_intro": "Lade Leute ein, an deiner Zeichnung mitzuarbeiten.",
    "desc_privacy": "Keine Sorge, die Sitzung ist Ende-zu-Ende verschlüsselt und vollständig privat. Nicht einmal unser Server kann sehen, was du zeichnest.",
    "button_startSession": "Sitzung starten",
    "button_stopSession": "Sitzung beenden",
    "desc_inProgressIntro": "Die Live-Sitzung wird nun ausgeführt.",
    "desc_shareLink": "Teile diesen Link mit allen, mit denen du zusammenarbeiten möchtest:",
    "desc_exitSession": "Wenn du die Sitzung beendest, wird deine Verbindung zum Raum getrennt. Du kannst jedoch lokal weiter an der Zeichnung arbeiten. Beachte, dass dies keine Auswirkungen auf andere hat und diese weiterhin gemeinsam an ihrer Version arbeiten können.",
    "shareTitle": "An einer Live-Kollaborationssitzung auf Excalidraw teilnehmen"
  },
  "errorDialog": {
    "title": "Fehler"
  },
  "exportDialog": {
    "disk_title": "Auf Festplatte speichern",
    "disk_details": "Exportiere die Zeichnungsdaten in eine Datei, die Du später importieren kannst.",
    "disk_button": "Als Datei speichern",
    "link_title": "Teilbarer Link",
    "link_details": "Als schreibgeschützten Link exportieren.",
    "link_button": "Als Link exportieren",
    "excalidrawplus_description": "Speichere die Szene in deinem Excalidraw+ Arbeitsbereich.",
    "excalidrawplus_button": "Exportieren",
    "excalidrawplus_exportError": "Konnte nicht nach Excalidraw+ exportieren..."
  },
  "helpDialog": {
    "blog": "Lies unseren Blog",
    "click": "klicken",
    "deepSelect": "Auswahl innerhalb der Gruppe",
    "deepBoxSelect": "Auswahl innerhalb der Gruppe, und Ziehen vermeiden",
    "createFlowchart": "Erstelle ein Flussdiagramm aus einem generischen Element",
    "navigateFlowchart": "Durchsuche ein Flussdiagramm",
    "curvedArrow": "Gebogener Pfeil",
    "curvedLine": "Gebogene Linie",
    "documentation": "Dokumentation",
    "doubleClick": "doppelklicken",
    "drag": "ziehen",
    "editor": "Editor",
    "editLineArrowPoints": "Linien-/Pfeil-Punkte bearbeiten",
    "editText": "Text bearbeiten / Label hinzufügen",
    "github": "Ein Problem gefunden? Informiere uns",
    "howto": "Folge unseren Anleitungen",
    "or": "oder",
    "preventBinding": "Pfeil-Bindung verhindern",
    "tools": "Werkzeuge",
    "shortcuts": "Tastaturkürzel",
    "textFinish": "Bearbeitung beenden (Texteditor)",
    "textNewLine": "Neue Zeile hinzufügen (Texteditor)",
    "title": "Hilfe",
    "view": "Ansicht",
    "zoomToFit": "Zoomen um alle Elemente einzupassen",
    "zoomToSelection": "Auf Auswahl zoomen",
    "toggleElementLock": "Auswahl sperren/entsperren",
    "movePageUpDown": "Seite nach oben/unten verschieben",
    "movePageLeftRight": "Seite nach links/rechts verschieben",
    "cropStart": "Bild zuschneiden",
    "cropFinish": "Zuschneiden des Bildes beenden"
  },
  "clearCanvasDialog": {
    "title": "Zeichenfläche löschen"
  },
  "publishDialog": {
    "title": "Bibliothek veröffentlichen",
    "itemName": "Elementname",
    "authorName": "Name des Autors",
    "githubUsername": "GitHub-Benutzername",
    "twitterUsername": "Twitter-Benutzername",
    "libraryName": "Name der Bibliothek",
    "libraryDesc": "Beschreibung der Bibliothek",
    "website": "Webseite",
    "placeholder": {
      "authorName": "Dein Name oder Benutzername",
      "libraryName": "Name deiner Bibliothek",
      "libraryDesc": "Beschreibung deiner Bibliothek, um anderen Nutzern bei der Verwendung zu helfen",
      "githubHandle": "GitHub-Handle (optional), damit du die Bibliothek bearbeiten kannst, wenn sie zur Überprüfung eingereicht wurde",
      "twitterHandle": "Twitter-Benutzername (optional), damit wir wissen, wen wir bei Werbung über Twitter nennen können",
      "website": "Link zu deiner persönlichen Webseite oder zu anderer Seite (optional)"
    },
    "errors": {
      "required": "Erforderlich",
      "website": "Gültige URL eingeben"
    },
    "noteDescription": "Sende deine Bibliothek ein, um in die <link>öffentliche Bibliotheks-Repository aufgenommen zu werden</link>damit andere Nutzer sie in ihren Zeichnungen verwenden können.",
    "noteGuidelines": "Die Bibliothek muss zuerst manuell freigegeben werden. Bitte lies die <link>Richtlinien</link> vor dem Absenden. Du benötigst ein GitHub-Konto, um zu kommunizieren und Änderungen vorzunehmen, falls erforderlich, aber es ist nicht unbedingt erforderlich.",
    "noteLicense": "Mit dem Absenden stimmst du zu, dass die Bibliothek unter der <link>MIT-Lizenz, </link>die zusammengefasst beinhaltet, dass jeder sie ohne Einschränkungen nutzen kann.",
    "noteItems": "Jedes Bibliothekselement muss einen eigenen Namen haben, damit es gefiltert werden kann. Die folgenden Bibliothekselemente werden hinzugefügt:",
    "atleastOneLibItem": "Bitte wähle mindestens ein Bibliothekselement aus, um zu beginnen",
    "republishWarning": "Hinweis: Einige der ausgewählten Elemente sind bereits als veröffentlicht/eingereicht markiert. Du solltest Elemente nur erneut einreichen, wenn Du eine existierende Bibliothek oder Einreichung aktualisierst."
  },
  "publishSuccessDialog": {
    "title": "Bibliothek übermittelt",
    "content": "Vielen Dank {{authorName}}. Deine Bibliothek wurde zur Überprüfung eingereicht. Du kannst den Status verfolgen<link>hier</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Bibliothek zurücksetzen",
    "removeItemsFromLib": "Ausgewählte Elemente aus der Bibliothek entfernen"
  },
  "imageExportDialog": {
    "header": "Bild exportieren",
    "label": {
      "withBackground": "Hintergrund",
      "onlySelected": "Nur ausgewählte",
      "darkMode": "Dunkler Modus",
      "embedScene": "Szene einbetten",
      "scale": "Skalierung",
      "padding": "Abstand"
    },
    "tooltip": {
      "embedScene": "Die Zeichnungsdaten werden in der exportierten PNG/SVG-Datei gespeichert, sodass das Dokument später weiter bearbeitet werden kann. \nDieses wird die exportierte Datei vergrößern."
    },
    "title": {
      "exportToPng": "Als PNG exportieren",
      "exportToSvg": "Als SVG exportieren",
      "copyPngToClipboard": "PNG in die Zwischenablage kopieren"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "In Zwischenablage kopieren"
    }
  },
  "encrypted": {
    "tooltip": "Da deine Zeichnungen Ende-zu-Ende verschlüsselt werden, sehen auch unsere Excalidraw-Server sie niemals.",
    "link": "Blogbeitrag über Ende-zu-Ende-Verschlüsselung in Excalidraw"
  },
  "stats": {
    "angle": "Winkel",
    "shapes": "Formen",
    "height": "Höhe",
    "scene": "Zeichnung",
    "selected": "Ausgewählt",
    "storage": "Speicher",
    "fullTitle": "Zeichenflächen- & Formeigenschaften",
    "title": "Eigenschaften",
    "generalStats": "Allgemein",
    "elementProperties": "Formeigenschaften",
    "total": "Gesamt",
    "version": "Version",
    "versionCopy": "Zum Kopieren klicken",
    "versionNotAvailable": "Version nicht verfügbar",
    "width": "Breite"
  },
  "toast": {
    "addedToLibrary": "Zur Bibliothek hinzugefügt",
    "copyStyles": "Formatierungen kopiert.",
    "copyToClipboard": "In die Zwischenablage kopiert.",
    "copyToClipboardAsPng": "{{exportSelection}} als PNG in die Zwischenablage kopiert\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "{{exportSelection}} als SVG in die Zwischenablage kopiert ({{exportColorScheme}})",
    "fileSaved": "Datei gespeichert.",
    "fileSavedToFilename": "Als {filename} gespeichert",
    "canvas": "Zeichenfläche",
    "selection": "Auswahl",
    "pasteAsSingleElement": "Verwende {{shortcut}} , um als einzelnes Element\neinzufügen oder in einen existierenden Texteditor einzufügen",
    "unableToEmbed": "Einbetten dieser URL ist derzeit nicht zulässig. Erstelle einen Issue auf GitHub, um die URL freigeben zu lassen",
    "unrecognizedLinkFormat": "Der Link, den Du eingebettet hast, stimmt nicht mit dem erwarteten Format überein. Bitte versuche den 'embed' String einzufügen, der von der Quellseite zur Verfügung gestellt wird",
    "elementLinkCopied": "Link in Zwischenablage kopiert"
  },
  "colors": {
    "transparent": "Transparent",
    "black": "Schwarz",
    "white": "Weiß",
    "red": "Rot",
    "pink": "Pink",
    "grape": "Traube",
    "violet": "Violett",
    "gray": "Grau",
    "blue": "Blau",
    "cyan": "Cyan",
    "teal": "Blaugrün",
    "green": "Grün",
    "yellow": "Gelb",
    "orange": "Orange",
    "bronze": "Bronze"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "Möchtest du stattdessen zu Excalidraw+ gehen?",
      "menuHint": "Exportieren, Einstellungen, Sprachen, ..."
    },
    "defaults": {
      "menuHint": "Exportieren, Einstellungen und mehr...",
      "center_heading": "Diagramme. Einfach. Gemacht.",
      "toolbarHint": "Wähle ein Werkzeug & beginne zu zeichnen!",
      "helpHint": "Kurzbefehle & Hilfe"
    }
  },
  "colorPicker": {
    "color": "Farbe",
    "mostUsedCustomColors": "Beliebteste benutzerdefinierte Farben",
    "colors": "Farben",
    "shades": "Schattierungen",
    "hexCode": "Hex-Code",
    "noShades": "Keine Schattierungen für diese Farbe verfügbar"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Als Bild exportieren",
        "button": "Als Bild exportieren",
        "description": "Exportiere die Zeichnungsdaten als ein Bild, von dem Du später importieren kannst."
      },
      "saveToDisk": {
        "title": "Auf Festplatte speichern",
        "button": "Auf Festplatte speichern",
        "description": "Exportiere die Zeichnungsdaten in eine Datei, von der Du später importieren kannst."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Export nach Excalidraw+",
        "description": "Speichere die Szene in deinem Excalidraw+-Arbeitsbereich."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Aus Datei laden",
        "button": "Aus Datei laden",
        "description": "Das Laden aus einer Datei wird <bold>Deinen vorhandenen Inhalt ersetzen</bold>.<br></br>Du kannst Deine Zeichnung zuerst mit einer der folgenden Optionen sichern."
      },
      "shareableLink": {
        "title": "Aus Link laden",
        "button": "Meinen Inhalt ersetzen",
        "description": "Das Laden einer externen Zeichnung wird <bold>Deinen vorhandenen Inhalt ersetzen</bold>.<br></br>Du kannst Deine Zeichnung zuerst mit einer der folgenden Optionen sichern."
      }
    }
  },
  "mermaid": {
    "title": "Mermaid zu Excalidraw",
    "button": "Einfügen",
    "description": "Derzeit werden nur <flowchartLink>Flussdiagramme</flowchartLink>, <sequenceLink>Sequenzdiagramme</sequenceLink> und <classLink>Klassendiagramme</classLink> unterstützt. Die anderen Typen werden als Bild in Excalidraw dargestellt.",
    "syntax": "Mermaid-Syntax",
    "preview": "Vorschau",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": "Schnellsuche"
  },
  "fontList": {
    "badge": {
      "old": "alt"
    },
    "sceneFonts": "In dieser Szene",
    "availableFonts": "Verfügbare Schriftarten",
    "empty": "Keine Schriftarten gefunden"
  },
  "userList": {
    "empty": "Keine Benutzer gefunden",
    "hint": {
      "text": "Klicke auf Benutzer um zu folgen",
      "followStatus": "Du folgst derzeit diesem Benutzer",
      "inCall": "Benutzer ist in einem Sprachanruf",
      "micMuted": "Mikrofon des Benutzers ist stumm geschaltet",
      "isSpeaking": "Benutzer spricht"
    }
  },
  "commandPalette": {
    "title": "Befehlspalette",
    "shortcuts": {
      "select": "Auswählen",
      "confirm": "Bestätigen",
      "close": "Schließen"
    },
    "recents": "Zuletzt verwendet",
    "search": {
      "placeholder": "Suche in Menüs und Befehlen, entdecke versteckte Funktionen",
      "noMatch": "Keine passenden Befehle..."
    },
    "itemNotAvailable": "Befehl ist nicht verfügbar...",
    "shortcutHint": "Benutze {{shortcut}} für Befehlspalette"
  },
  "keys": {
    "ctrl": "Strg",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "Leertaste",
    "delete": "Löschen",
    "mmb": "Mausrad"
  }
}
